module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[99]586.e0ce36b.woff2";